import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "components/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "components/ui/select";

interface FilterOperationTypeProps {
  control: any;
  errors: any;
}

const OPTIONS = [
  { value: "todos", label: "Todos" },
  { value: "4", label: "Vendas" },
  { value: "182", label: "Fatura/Acordo" },
  { value: "191", label: "Sabadão Premiado" },
];

export function FilterOperationType({
  control
}: FilterOperationTypeProps) {
  return (
    <FormField
      control={control}
      name="operationType"
      render={({ field }) => (
        <FormItem className="space-y-2">
          <FormLabel className="block text-sm font-medium text-gray-700">
            Tipo de Operação *
          </FormLabel>
          <FormControl>
            <Select value={field.value} onValueChange={field.onChange}>
              <SelectTrigger className="flex items-center w-full h-[50px] px-4 py-2 border rounded-lg text-left text-gray-700 shadow-sm">
                <SelectValue placeholder="Selecione o tipo" />
              </SelectTrigger>
              <SelectContent className="w-[--radix-select-trigger-width]">
                {OPTIONS.map((opt) => (
                  <SelectItem
                    key={opt.value}
                    value={opt.value}
                    className="text-gray-700"
                  >
                    {opt.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}